import * as React from "react";
import { Form, Dropdown as SemanticDropdown } from "semantic-ui-react";
export const INPUT_TYPE_TEXT = "text";
export const INPUT_TYPE_PASSWORD = "password";
export const Dropdown = ({ name, label, error, inline, ...rest }: any) => {
  return (
    <Form.Field
      inline={inline}
      error={
        error && {
          content: { error },
          pointing: "left",
        }
      }
    >
      <label htmlFor={name}>{label}</label>
      <SemanticDropdown {...rest} name={name} id={name} />
    </Form.Field>
  );
};



// WEBPACK FOOTER //
// ./src/components/Form/dropdown.tsx